<template>
    <CustomTopSheetDialog v-model="dialogVisible" :width="1200" :title="null" :customclass="'px-4 pt-4'">
        <template #title>
            <h3 class="text-left dialog-title" color="primary">
                Replies of comment: "{{ formData.headline }}"
            </h3>
        </template>

        <template #default>
            <v-row class="shop-info-container">
                <v-col cols="12">
                    <CommentsGridList :comments="formData.replies" :perPage="12" />
                </v-col>
            </v-row>
            <CustomConfirmDeletionDialog v-model="showDeleteDialog" :confirm-deletion="deleteComment"
                v-model:data="removedComment" :title="'Delete Comment'"
                :question="`Are you sure you want to Delete the comment ?`">
            </CustomConfirmDeletionDialog>
            <!-- {{ formData }} -->
        </template>

        <template #actions>
            <v-container class="d-flex align-items-center justify-content-end">
                <v-btn class="px-3 py-1 mr-3" variant="flat" rounded="xl" size="large" prepend-icon="mdi-cancel"
                    color="default" @click="closeSheet">{{ $t('entity.action.close') }}</v-btn>
                <!-- <v-btn class="px-3 py-1" variant="flat" rounded="xl" size="large" prepend-icon="mdi-content-save"
                    color="primary" @click="save">{{ $t('global.form.save') }}</v-btn> -->
            </v-container>
        </template>
    </CustomTopSheetDialog>
</template>


<script>
export default {
    name: "ShopTargetDialog",
    data() {
        return {
        }
    },
    methods: {
    },
};
</script>
<script setup>
import { ref, inject, onMounted, computed, watch, getCurrentInstance, defineProps, defineEmits, defineModel } from 'vue';
import CustomTopSheetDialog from '@/components/custom/CustomTopSheetDialog.vue';
import LabelCategories from '../LabelCategories.vue';
import CustomConfirmDeletionDialog from './CustomConfirmDeletionDialog.vue';
import CommentsGridList from '@/components/custom/CommentsGridList.vue';

const { proxy } = getCurrentInstance();
const dialogVisible = defineModel(); // Handles v-model for visibility
const formData = defineModel("data", { default: () => ({}) }); // Handles v-model for the object
const selectedLanguage = localStorage.getItem('selectedLanguage');
const softToken = localStorage.getItem("softToken");
const hardToken = localStorage.getItem("hardToken");
const username = localStorage.getItem("username");
const props = defineProps({
    save: Function, // Define prop as a function
    items: Array
});

const repliesVisible = ref(false);
const parentComment = ref(null);
const itemsPerPage = ref(50);
const showDeleteDialog = ref(false);
const removedComment = ref(null);
const pageOptions = [
    { value: 50, title: '50' },
    { value: 100, title: '100' },
    { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' },
];
const headers = computed(() => [
  { title: 'Username', key: 'username' },
  { title: 'Text', key: 'text' },
  { title: 'Replies', key: 'replies' },
  { title: 'Actions', key: 'controls', align:"center",width:'200px' },
//   {
//     title: search.value
//       ? 'Matching Replies'
//       : 'All Replies',
//     key: 'data-table-expand',
//     width: 200
//   },
]);
const subHeaders = [
    { title: 'Username', key: 'user.username', align: 'start', },
    { title: 'Text', key: 'text', align: 'start' },
    { title: 'Actions', key: 'controls', align: 'end', sortable: false },
];

const search = ref('');
const serverItems = ref([]);
const totalItems = ref(0);
const loading = ref(false);
const expanded = ref([]);


let lastOptions = { page: 1, itemsPerPage: itemsPerPage.value, sortBy: [] };

function onUpdateOptions(options) {
    lastOptions = options;
    fetchPage(options);
}


async function fetchPage({ page, itemsPerPage, sortBy }) {
    const id = formData.value?.id;
    if (!id) return;              // guard: no ID yet

    loading.value = true;

    const hardToken = localStorage.getItem('hardToken');
    const username = localStorage.getItem('username');

    const sort = Array.isArray(sortBy) && sortBy.length ? sortBy[0] : null;
    const params = {
        page: (page ?? 1) - 1,
        resultsPerPage: itemsPerPage ?? 50,
        ...(search.value ? { search: search.value } : {}),
        ...(sort ? {
            sortColumn: sort.key === 'registered' ? 'created' : sort.key,
            sortDirection: (sort.order || 'asc').toUpperCase(),
        } : {}),
    };

    try {
        const res = await proxy.$axios.get(`/backoffice/shopstream/${id}/comments`, {
            headers: {
                'X-Auth-HARDTOKEN': hardToken,
                'X-Auth-USER': username,
            },
            params,
        });

        const rows = res.data?.data ?? [];
        totalItems.value = res.data?.totalElements ?? 0;

        // Make sure replies exists so it’s reactive
        serverItems.value = rows.map(r => ({ ...r, replies: Array.isArray(r.replies) ? r.replies : [] }));

        // Fetch replies for the page’s items (parallel)
        await fetchRepliesFor(serverItems.value);
    } catch (e) {
        console.error('Error fetching comments:', e);
        serverItems.value = [];
        totalItems.value = 0;
    } finally {
        loading.value = false;
    }
}

// re-fetch when (a) dialog opens with an id or (b) the id changes while open
// watch(search, (newSearch) => {
//   console.log(newSearch);

//   // Make sure the header exists
//   if (headers.value?.[3]) {
//     headers.value[3].title = newSearch
//       ? 'Matching Replies / All Replies'
//       : 'All Replies';
//   }
// });
watch(
    [dialogVisible, () => formData.value?.id],
    ([open, id], [prevOpen, prevId]) => {
        if (open && id && (!prevOpen || id !== prevId)) {
            // If the table is mounted now, v-data-table-server will emit @update:options by itself.
            // But in case it doesn't (or to be explicit), trigger with lastOptions:
            fetchPage(lastOptions);
        }
    },
    { immediate: false }
);

async function fetchRepliesFor(items) {
    const hardToken = localStorage.getItem('hardToken');
    const username = localStorage.getItem('username');

    const headers = {
        'X-Auth-HARDTOKEN': hardToken,
        'X-Auth-USER': username,
    };

    // tune as needed; your backend allows up to 500
    const page = 0;
    const resultsPerPage = 200;

    // Fetch all in parallel
    await Promise.all(items.map(async (item) => {
        try {
            const res = await proxy.$axios.get(`/backoffice/shopstream/comment/${item.id}/reply`, {
                headers,
                params: { page, resultsPerPage,...(search.value ? { search: search.value } : {}),},
            });
            const replies = res?.data?.data ?? [];
            // assign so Vue tracks it
            item.replies = replies;
        } catch (err) {
            console.error(`Failed to fetch replies for ${item.id}:`, err);
            item.replies = [];
        }
    }));
}

// search re-fetch (debounce if you like)
watch(search, () => {
    if (dialogVisible.value && formData.value?.id) {
        fetchPage({ ...lastOptions, page: 1, itemsPerPage: itemsPerPage.value, sortBy: lastOptions.sortBy || [] });
    }
});

watch(expanded, (now, prev) => {
    const newlyExpanded = now.filter(id => !prev.includes(id));
    if (!newlyExpanded.length) return;

    newlyExpanded.forEach(async (id) => {
        const item = serverItems.value.find(x => x.id === id);
        if (!item) return;
        if (item.replies?.length) return; // already loaded
        await fetchRepliesFor([item]);
    });
});

function showComments(item) {
    parentComment.value = item;
    repliesVisible.value = true
}

function removeComment(item) {
    removedComment.value = item;
    showDeleteDialog.value = true;
}

async function deleteComment(item) {
    if(!item.id) return;
    console.log(item);
    try {
        const res = await proxy.$axios.delete(`/backoffice/shopstream/comment/${item.id}`, {
            headers: {
                'X-Auth-HARDTOKEN': hardToken,
                'X-Auth-USER': username,
            },
        });
        
    } catch (e) {
        console.error('Error fetching comments:', e);
        serverItems.value = [];
        totalItems.value = 0;
    } finally {
        loading.value = false;
        showDeleteDialog.value = false;
        onUpdateOptions({ ...lastOptions, page: 0, itemsPerPage: itemsPerPage.value, sortBy: lastOptions.sortBy || [] });
    }
}

const closeSheet = () => {
    dialogVisible.value = false;
    formData.value = {};
};
onMounted(() => {

});
</script>

<style>
.v-field--appended {
    padding-inline-end: 0px !important;
}

.v-col>.v-label,
.v-col>.v-checkbox .v-label {
    font-weight: 700;
    font-size: 14px;
    opacity: 1;
}

.shop-description-input textarea,
.shop-info-container .v-field__input {
    font-size: 14px !important;
    font-weight: 300 !important;
}

.emoji-picker-container {
    width: 300px;
    /* Adjust width as needed */
    height: 400px;
    /* Adjust height as needed */
    overflow-y: auto;
    /* Add scroll if content overflows */
    padding: 8px;
}

.date-picker .v-field .v-field__append-inner {
    background-color: rgb(var(--v-theme-default)) !important;
}

.time-input .v-field__input {
    padding-right: 0px;
}

.create-news-tabs .v-tab {
    font-weight: 600 !important;
}
</style>

<style scoped>
.v-tab-selected {
    border: 1px solid #ddd !important;
    border-bottom: 0 !important;
}

.v-window-item--active {
    border-top: 0 !important;
    border: 1px solid #ddd !important;
}

.highlighted-country {
    font-weight: 800;
}

.expanded-row {
    border-bottom: thick solid rgba(var(--v-border-color), var(--v-border-opacity));
    border-top: thick solid rgba(var(--v-border-color), var(--v-border-opacity));
}
</style>
